import "./az.css";
import React, { useState } from 'react';


export default function Az()
 {  

    return    (
    <div id="wrapper">
       
       <div>Folgt in Kürze</div>
       </div>
    )

 }


